import { useStores } from "stores/setup/use-store";
import { StoreState } from "enum/StoreState";

export const useIsLoading = (): boolean => {
  const {
    dataStores: { forecastChartPageStore },
  } = useStores();
  return forecastChartPageStore.statePDFReport === StoreState.PEDDING;
};
